import { ChangeEvent, FunctionComponent } from 'react';
import { SliderProps } from './SliderProps';

export const Slider: FunctionComponent<SliderProps> = ({ defaultValue, min, max, className, onChange }) => {
  function onValueChange(event: ChangeEvent<HTMLInputElement>): void {
    onChange(parseInt(event.target.value));
  }

  return (
    <input
      className={className}
      type="range"
      defaultValue={defaultValue}
      min={min}
      max={max}
      onChange={onValueChange}
    />
  );
};
